/**
 * Notifications API — digest subscription CRUD (P0.3).
 *
 * The bell-style notification list, mark-read, preferences endpoints
 * are still consumed inline elsewhere. This file ships the digest
 * subscription wrapper because it's a clean new surface and the UI
 * lives in one page (System / Settings / Notifications).
 */
import { http } from './client';

export type DigestReportType =
  | 'attendance_admin'
  | 'attendance_worker_personal'
  | 'process_admin';
export type DigestCadence = 'daily' | 'weekly';

export interface DigestSubscriptionResponse {
  id: string;
  organization_id: string;
  worker_id: string;
  report_type: DigestReportType | string;
  cadence: DigestCadence | string;
  enabled: boolean;
  last_sent_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface DigestSubscriptionCreate {
  report_type: DigestReportType;
  cadence: DigestCadence;
  enabled?: boolean;
}

export interface DigestSubscriptionUpdate {
  cadence?: DigestCadence;
  enabled?: boolean;
}

export const digestsApi = {
  list: () =>
    http.get<DigestSubscriptionResponse[]>('/v1/notifications/digests'),
  create: (data: DigestSubscriptionCreate) =>
    http.post<DigestSubscriptionResponse>('/v1/notifications/digests', data),
  update: (id: string, data: DigestSubscriptionUpdate) =>
    http.patch<DigestSubscriptionResponse>(
      `/v1/notifications/digests/${id}`, data,
    ),
  delete: (id: string) =>
    http.delete(`/v1/notifications/digests/${id}`),
};
